import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { initialAllOptionPromises } from '../../../../../helper/utils';
import { usePropsSelect } from '../../../../../hooks/useProps/usePropsSelect';
import { useGetOptionsSelect } from '../../../../../hooks/useGetOptionsSelect/useGetOptionsSelect';
import { useManageGetRequest } from '../../../../../hooks/useManageGetRequest/useManageGetRequest';
import { usePropsInputs } from '../../../../../hooks/useProps/usePropsInput';
import useDidMountEffect from '../../../../../hooks/useDidMountEffect/useDidMountEffect';
import { useSubmitForm } from '../../../../../hooks/useSubmitForm/useSubmitForm';
import InputDate from '../../../../../components/modalComponents/InputDate';
import FooterModal from '../../../../../components/modalComponents/FooterModal';
import InputSelect from '../../../../../components/modalComponents/InputSelect';
import CardAccordion from '../../../../../components/pageComponents/CardAccordion';
import SpinnerLoading from '../../../../../components/pageComponents/SpinnerLoading';
import { KEYS_DATOS_NACIMIENTO_NI, KEYS_CARD_NUEVOS_INGRESOS as OPTIONS, PAISES } from '../../../../../constants/hardCodedConstants';
import { getDatosNacimientoGestionAPI, getDepartamentosAPI, getDistritosPorProvinciaAPI, getPaisesAPI, getProvinciasPorDepartamentoAPI, saveDatosNacimientoAPI } from '../../../../../consumers/backendApisUrls';
import InputText from '../../../../../components/modalComponents/InputText';
import { useForm } from '../../../../../hooks/useForm/UseForm';

const PruebaPsicologicaII = ({ idNuevosIngresosEmpleado, idParent: ID_PARENT, isColaborador, inputDisabled, sendCurrentStep, setSendCurrentStep, componentStep }) => {

  const SECTION_NAME = "EditarDatosNacimientoFichaNuevosIngresos";
  const KEYS_INIT = {Pais: "IdPaisNacimiento"};

  const [allDropdowns, setAllDropdowns] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [allIdDepartamento, setAllIdDepartamento] = useState([]);
  const [allIdProvincia, setAllIdProvincia] = useState([]);
  const [allIdDistrito, setAllIdDistrito] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);

  const [handleChange] = useForm(formValues, setFormValues);
  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [commonPropsSelect] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);
  const [submitForm] = useSubmitForm();
  const [getOptions] = useGetOptionsSelect();
  const [executeGet] = useManageGetRequest();

  const allGetPromises = () => {
    return [
      getOptions(getPaisesAPI()),
    ]
  }

  const init = async () => {
    try {
      let { data } = await manageSearch();
      initialAllOptionPromises(allGetPromises, Object.values(KEYS_INIT), (res) => successInitCallback(res, data));
    } catch (error) {
      console.error(error);
    }
  }

  const manageSearch = async () => {
    const api = getDatosNacimientoGestionAPI(idNuevosIngresosEmpleado);
    return await executeGet(api, (res) => setFormValues(res.data));
  }

  const successInitCallback = async (res, initValues) => {
    setAllDropdowns(res);
    initValues?.IdPaisNacimiento === PAISES.PERU && getDepartamentos();
    initValues?.IdDepartamento && getProvinciasPorDepartamento(initValues?.IdDepartamento);
    initValues?.IdProvincia && getDistritosPorProvincia(initValues?.IdProvincia);
    setIsLoading(false);
  }

  const handleSubmit = async (e) => {
    if(e) e.preventDefault();
    setIsSending(true);
    try {
      const api = saveDatosNacimientoAPI();
      await submitForm(KEYS_DATOS_NACIMIENTO_NI, api, formValues, SECTION_NAME, successSubmitCallback, !isColaborador, () => toast.error("Faltan completar datos"));
    } catch (error) {
      console.error(error);
    } finally{
      setIsSending(false);
    }
  }

  const successSubmitCallback = () => {
    manageSearch();
    if(isColaborador) setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
  }

  const handleChangeSelect = (res, key) => {
    setFormValues(lastData => ({...lastData, [key]: res.target?.value?.value}));
  }

  const cleanDropdownSelected = (keys) => {
    keys.map(o => setFormValues(lastData => ({...lastData, [o]: ""})));
  }

  const handleCountryChange = () => {
    if (formValues.IdPaisNacimiento === PAISES.PERU) {
      getDepartamentos();
    } else {
      setAllIdDepartamento([]);
      setAllIdProvincia([]);
      setAllIdDistrito([]);
    }
  }

  const getDepartamentos = async () => {
    const departamentos = await getOptions(getDepartamentosAPI());
    setAllIdDepartamento(departamentos);
  }

  const getProvinciasPorDepartamento = async (initialValues = null) => {
    const provincias = await getOptions(getProvinciasPorDepartamentoAPI(initialValues ?? formValues.IdDepartamento))
    setAllIdProvincia(provincias);
  }

  const getDistritosPorProvincia = async (initialValues = null) => {
    const distritos = await getOptions(getDistritosPorProvinciaAPI(initialValues ?? formValues.IdProvincia));
    setAllIdDistrito(distritos);
  }

  useDidMountEffect(() => {
    if(formValues.IdPaisNacimiento && !isLoading) {
      cleanDropdownSelected(["IdDepartamento", "IdProvincia", "IdDistrito"]);
      handleCountryChange();
    };
  }, [formValues.IdPaisNacimiento])

  useDidMountEffect(() => {
    if(formValues.IdDepartamento && !isLoading) {
      cleanDropdownSelected(["IdProvincia", "IdDistrito"]);
      getProvinciasPorDepartamento();
    };
  }, [formValues.IdDepartamento])
  
  useDidMountEffect(() => {
    if(formValues.IdProvincia && !isLoading) {
      cleanDropdownSelected(["IdDistrito"]);
      getDistritosPorProvincia();
    };
  }, [formValues.IdProvincia])

  useDidMountEffect(() => {
    if (isColaborador && sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent){
      handleSubmit();
    }
  }, [sendCurrentStep])

  useEffect(() => {
    init();
  }, [])

  if (isLoading) return <SpinnerLoading/>

  return (
    <form onSubmit={handleSubmit} className={`${isColaborador ? "form-colaborador-inputs" : ""}`} >
      <CardAccordion id={OPTIONS.idDatosNacimiento} idParent={ID_PARENT} label="2. Datos de Nacimiento" isShow isShowGeneral={!isColaborador}>
        <div className="displayFlexWrap mt-4">
          <DivCol required><InputDate label="Fecha de nacimiento" {...commonProps('FechaNacimiento')} direction='column' isDisabled={inputDisabled}/></DivCol>
          <DivCol required><InputSelect label="País" {...commonPropsSelect("IdPaisNacimiento")} direction='column' isDisabled={inputDisabled}/></DivCol>
          {formValues.IdPaisNacimiento === PAISES.PERU ?
            <>
              <DivCol required><InputSelect label="Departamento" name="IdDepartamento" options={allIdDepartamento} value={allIdDepartamento?.find(o => o.value === formValues.IdDepartamento)} onChange={(res) => handleChangeSelect(res, "IdDepartamento")} sectionName={SECTION_NAME} direction='column' isDisabled={inputDisabled}/></DivCol>
              <DivCol required><InputSelect label="Provincia" name="IdProvincia" options={allIdProvincia} value={allIdProvincia?.find(o => o.value === formValues.IdProvincia)} onChange={(res) => handleChangeSelect(res, "IdProvincia")} sectionName={SECTION_NAME} direction='column' isDisabled={inputDisabled}/></DivCol>
              <DivCol required><InputSelect label="Distrito" name="IdDistrito" options={allIdDistrito} value={allIdDistrito?.find(o => o.value === formValues.IdDistrito)} onChange={(res) => handleChangeSelect(res, "IdDistrito")} sectionName={SECTION_NAME} direction='column' isDisabled={inputDisabled}/></DivCol>
            </>  :
            <DivCol required><InputText label="Ciudad" name="CiudadNacimiento" value={formValues.CiudadNacimiento} onChange={handleChange} sectionName={SECTION_NAME} direction='column' isDisabled={inputDisabled}/></DivCol>
          }
        </div>
        {(!inputDisabled && !isColaborador) && <FooterModal isDisabled={isSending}/>}
      </CardAccordion>
    </form>
  )
}

export default PruebaPsicologicaII;

const DivCol = ({ children, required }) => {
  return (
    <div className={`col-md-4 ${required ? "div-label-required" : ""}`}>
      {children}
    </div>
  )
}